import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { ListWidgetComponentFactory } from '~/components/MyWorkspace/ListWidget';
import { useNotificationList } from '~/hooks/useNotificationList';
import { People } from '~/services/Http';

import { WidgetProps } from '../../data/widgets';

import { MyNotificationsWidgetHeader } from './components/MyNotificationsWidgetHeader';
import { Notification } from './components/Notification';

export const revalidateNotificationsInterval = 60 * 1000;

export interface Props extends WidgetProps {}

const MyNotificationsWidgetComponent = ListWidgetComponentFactory({
  ListItemComponent: Notification,
  getIdentifier: (item: People.INotificationDto) => item.id,
  TitleComponent: MyNotificationsWidgetHeader,
  dataCy: 'notifications-widget',
});

export const MyNotificationsWidget: React.FC<Props> = ({ title }) => {
  const { t } = useTranslation();

  const swrConfig = useMemo(
    () => ({ refreshInterval: revalidateNotificationsInterval }),
    [],
  );

  const {
    notifications,
    loading,
    failedToLoad,
    onMarkAsUnread,
    onMarkAsRead,
    onDeleteNotification,
  } = useNotificationList({ limit: 50 }, swrConfig);

  return (
    <MyNotificationsWidgetComponent
      title={title || t('myNotifications')}
      data={notifications}
      loading={loading}
      failedToLoad={failedToLoad}
      noDataMessage={t('noNotifications')}
      customActions={{
        onMarkAsRead,
        onMarkAsUnread,
        onDeleteNotification,
      }}
    />
  );
};
